// extracted by mini-css-extract-plugin
module.exports = {"conteiner":"right-block_conteiner__V5Jzk"};